import { fetchTokenAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { exactUrlToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const radSecurity = defineConnector({
  identifier: "radSecurity",
  name: "RAD Security",
  tagLine: "Cloud runtime security",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ baseUrl }) =>
    exactUrlToRegex(baseUrl || "https://api.rad.security"),
  auth: ({ configuration }) =>
    fetchTokenAuth({
      request: {
        url: {
          from: "literal",
          value:
            (configuration.baseUrl || "https://api.rad.security")
              .trim()
              .replace(/\/+$/, "") + "/authentication/authenticate",
        },
        headers: [],
        jsonBody: {
          access_key_id: { from: "secret", field: "accessKeyId" },
          secret_key: { from: "secret", field: "secretKey" },
        },
      },
      extract: { from: "jsonPath", paths: ["token"] },
      apply: {
        kind: "header",
        name: "Authorization",
        scheme: "Bearer",
        extraHeaders: [],
      },
    }),
  steps: [
    {
      title: "Set up RAD Security",
      items: [
        {
          kind: "markdown",
          content:
            "Create an access key in your tenant’s access-key settings. Enter the key ID and secret below. See [API authentication](https://docs.rad.security/api-reference/introduction).",
        },
      ],
    },
    {
      title: "Enter connection details",
      items: [
        {
          kind: "baseUrl",
          label: "API base URL",
          required: true,
          defaultValue: "https://api.rad.security",
          target: {
            kind: "configuration",
            field: "baseUrl",
          },
          helperText:
            "Use https://api.rad.security, or the API base URL provided for your RAD Security deployment.",
        },
        {
          kind: "input",
          label: "Access key ID",
          required: true,
          target: {
            kind: "secrets",
            field: "accessKeyId",
          },
          helperText:
            "Create an access key in RAD Security’s tenant access-key settings, then use its key ID as the access_key_id value in the authentication request.",
        },
        {
          kind: "input",
          label: "Secret key",
          required: true,
          target: {
            kind: "secrets",
            field: "secretKey",
          },
          helperText:
            "Copy the secret generated with the RAD Security access key and use it as the secret_key value in the authentication request.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ baseUrl }) => ({
      url:
        (baseUrl || "https://api.rad.security").trim().replace(/\/+$/, "") +
        "/accounts",
      ...{ method: "GET" },
    }),
  },
});
